/* eslint-disable no-constant-condition */
import React, { useEffect, useState } from 'react'
import '../../Styles/ViewRiskDetailsById.css'
// import { RiVideoAddLine } from 'react-icons/ri'
import { MdAccessTime, MdOutlineCalendarMonth } from 'react-icons/md'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Typography from '@mui/material/Typography'
import { IoIosArrowDown } from 'react-icons/io'
import { IoCheckmarkCircle } from 'react-icons/io5'
import { Box, IconButton, Tooltip } from '@mui/material'
import RiskSummary from '../../Components/Risk/RiskSummary'
import QualitiativeRiskAssesment from '../../Components/Risk/QualitiativeRiskAssesment'
import QuantitiativeRiskAssesment from '../../Components/Risk/QuantitiativeRiskAssesment'
import DateInput from '../../Common/ui/dateInput'
import { useForm } from 'react-hook-form'
import Input from '../../Common/ui/input'
import ToggleSwitch from '../../Common/ui/ToggleSwitch'
import { Button } from '../../Common/ui/button'
import { useTranslation } from 'react-i18next'
import Mitigation from '../../Components/Risk/Mitigation'
import useCustomNavigate from '../../Common/ui/Navigate'
import * as RoutePath from '../../Entities/RoutePath'
import { useRiskStore } from './Store/RiskStore'
import Loading from '../../Common/ui/Loading'
import { useLocation } from 'react-router'
import ViewRisk from './ViewRisk'
import * as RiskAPI from '../../API/RiskAPI'
import { INITIATE } from 'src/Entities/CommonEntities'

const ViewRiskDetailsById = () => {
    const customNavigate = useCustomNavigate()
    const [ checked, setChecked ] = useState(false)
    const { register, handleSubmit, formState: { errors, isSubmitting, isLoading }, control } = useForm({ mode: 'onChange' })
    const [ expanded, setExpanded ] = React.useState(false)
    const { t } = useTranslation()
    const { CreateRisk, RiskDetailsById, RiskDetailsByIdLoading, getRidkDetailsById, createRiskDataLoading, getRiskDetailsMonitoring, getRiskDetailsMitigation, getRiskDetailsAnalyz, getRiskDetailsInitial } = useRiskStore()
    const [ AllFormData, setAllFormData ] = useState(RiskDetailsById)

    const location = useLocation()

    const handleChangeRiskAccordian = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false)
    }

    const handleCancel = () => {
        const l1Approval = {
            contextId: AllFormData?.contextId,
            title: AllFormData?.title,
            description: AllFormData?.description,
            // identifiedOn: typeof AllFormData?.identifiedOn,
            identifiedOn: new Date()?.toISOString(),
            sourceRiskId: 1,
            type: 1,
            category: 1,
            impactedDepartmentIds: [
                1
            ],
            impactOfRisk: AllFormData?.impactOfRisk,
            ownerDepartmentId: 1,
            impact: typeof AllFormData?.impact === 'string' ? AllFormData?.impact.split('(') : AllFormData?.impact,
            probability: typeof AllFormData?.probability === 'string' ? AllFormData?.probability.split('(') : AllFormData?.probability,
            riskScore: typeof AllFormData?.riskScore === 'string' ? AllFormData?.riskScore.split('(') : AllFormData?.riskScore,
            suggestedMitigation: AllFormData?.suggestedMitigation,
            suppprtingDocuments: AllFormData?.suppprtingDocuments,
            level1: AllFormData?.level1 === 8 ? 12 : AllFormData?.level1,
            level2: AllFormData?.level1 === 3 ? 12 : 8,
            Status: 12
        }
        const formValue = new FormData()
        Object.entries(l1Approval).forEach(([ key, value ]) => {
            formValue.append(key, value)
        })
        CreateRisk(1, formValue)
        if (!createRiskDataLoading) {
            customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE, <div>{RoutePath.RISK.NAME}</div>)
        }
    }

    const handleSubmitViewRiskDetails = () => {
        if (location?.state?.selectedMenu === 'Initiation') {
            const l1Approval = {
                contextId: AllFormData?.contextId,
                title: AllFormData?.title,
                description: AllFormData?.description,
                // identifiedOn: AllFormData?.identifiedOn,
                identifiedOn: new Date()?.toISOString(),
                sourceRiskId: 1,
                type: 1,
                category: 1,
                impactedDepartmentIds: [
                    1
                ],
                impactOfRisk: AllFormData?.impactOfRisk,
                ownerDepartmentId: 1,
                impact: typeof AllFormData?.impact === 'string' ? AllFormData?.impact.split('(') : AllFormData?.impact,
                probability: typeof AllFormData?.probability === 'string' ? AllFormData?.probability.split('(') : AllFormData?.probability,
                riskScore: typeof AllFormData?.riskScore === 'string' ? AllFormData?.riskScore.split('(') : AllFormData?.riskScore,
                suggestedMitigation: AllFormData?.suggestedMitigation,
                suppprtingDocuments: AllFormData?.suppprtingDocuments,
                level1: AllFormData?.level1 === 8 ? 3 : AllFormData?.level1,
                level2: AllFormData?.level1 === 3 ? 3 : AllFormData?.level1,
                Status: AllFormData?.level1 === 3 ? 3 : 1
            }
            const formValue = new FormData()
            Object.entries(l1Approval).forEach(([ key, value ]) => {
                formValue.append(key, value)
            })
            CreateRisk(1, formValue)
            setTimeout(() => {
                getRiskDetailsInitial(1, 10, 1, 1, 1)
                getRiskDetailsAnalyz(1, 10, 1, 2, 1)
                getRiskDetailsMitigation(1, 10, 1, 3, 1)
                getRiskDetailsMonitoring(1, 10, 1, 4, 1)
                customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE, <div>{RoutePath.RISK.NAME}</div>)
            }, 1500)
        } else if (location?.state?.selectedMenu === 'Analyze') {
            RiskAPI.createQuantitativeRiskAssessment({
                contextId: AllFormData?.contextId,
                event: 1,
                eventDescription: AllFormData?.quantitativeRiskAssessment?.eventDescription,
                sleValue: Number(AllFormData?.quantitativeRiskAssessment?.sleValue),
                aro: Number(AllFormData?.quantitativeRiskAssessment?.aro),
                aleValue: Number(AllFormData?.quantitativeRiskAssessment?.aleValue) || Number(AllFormData?.quantitativeRiskAssessment?.sleValue) * Number(AllFormData?.quantitativeRiskAssessment?.aro),
                justification: 1,
                justificationDescription: AllFormData?.quantitativeRiskAssessment?.justificationDescription,
                qraImpact: AllFormData?.quantitativeRiskAssessment?.qraImpact
            })
                .then((res) => console.log(res))
                .catch((err) => console.warn(err))

            RiskAPI.createQualitativeRiskAssessment({
                contextId: AllFormData?.contextId,
                referenceId: AllFormData?.referenceId,
                // impact: typeof AllFormData?.alitativeRiskAssessment?.mitigationImpact === 'string' ? AllFormData?.alitativeRiskAssessment?.mitigationImpact?.split('(')[0] : AllFormData?.alitativeRiskAssessment?.mitigationImpact,
                // probability: typeof AllFormData?.alitativeRiskAssessment?.mitigationProbability === 'string' ? AllFormData?.alitativeRiskAssessment?.mitigationProbability?.split('(')[0] : AllFormData?.alitativeRiskAssessment?.mitigationProbability,
                // riskScore: typeof AllFormData?.alitativeRiskAssessment?.mitigationRiskScore === 'string' ? AllFormData?.alitativeRiskAssessment?.mitigationRiskScore?.split('(')[0] : AllFormData?.alitativeRiskAssessment?.mitigationRiskScore,
                impact: 3,
                probability: 3,
                riskScore: 9,
                probabilityJustification: AllFormData?.probabilityJustification,
                riskScoreImpact: AllFormData?.riskScoreImpact
            })
                .then((res) => {
                    if (res?.err) {
                        console.warn(res.err)
                        return
                    }
                    getRiskDetailsInitial(1, 10, 1, 1, 1)
                    getRiskDetailsAnalyz(1, 10, 1, 2, 1)
                    getRiskDetailsMitigation(1, 10, 1, 3, 1)
                    getRiskDetailsMonitoring(1, 10, 1, 4, 1)
                })
                .catch((err) => console.warn(err))
            const l1Approval = {
                contextId: AllFormData?.contextId,
                title: AllFormData?.title,
                description: AllFormData?.description,
                // identifiedOn: AllFormData?.identifiedOn,
                identifiedOn: new Date()?.toISOString(),
                sourceRiskId: 1,
                type: 1,
                category: 1,
                impactedDepartmentIds: [
                    1
                ],
                impactOfRisk: AllFormData?.impactOfRisk,
                ownerDepartmentId: 1,
                impact: typeof AllFormData?.impact === 'string' ? AllFormData?.impact.split('(') : AllFormData?.impact,
                probability: typeof AllFormData?.probability === 'string' ? AllFormData?.probability.split('(') : AllFormData?.probability,
                riskScore: typeof AllFormData?.riskScore === 'string' ? AllFormData?.riskScore.split('(') : AllFormData?.riskScore,
                suggestedMitigation: AllFormData?.suggestedMitigation,
                suppprtingDocuments: AllFormData?.suppprtingDocuments,
                level1: AllFormData?.level1,
                level2: AllFormData?.level2,
                Status: 10
            }
            const formValue = new FormData()
            Object.entries(l1Approval).forEach(([ key, value ]) => {
                formValue.append(key, value)
            })
            CreateRisk(1, formValue)
            setTimeout(() => {
                customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE, <div>{RoutePath.RISK.NAME}</div>)
            }, 1000)
        } else if (location?.state?.selectedMenu === 'MitigationPlan') {
            RiskAPI.createTasks({
                riskScore: {
                    contextId: AllFormData?.contextId,
                    impact: 3,
                    probability: 3,
                    riskScore: 9,
                    // impact: typeof AllFormData?.impact === 'string' ? AllFormData?.impact.split('(') : AllFormData?.impact,
                    // probability: typeof AllFormData?.probability === 'string' ? AllFormData?.probability.split('(') : AllFormData?.probability,
                    // riskScore: typeof AllFormData?.riskScore === 'string' ? AllFormData?.riskScore.split('(') : AllFormData?.riskScore,
                    probabilityJustification: AllFormData?.probabilityJustification || 'probabilityJustification',
                    riskScoreImpact: AllFormData?.riskScoreImpact || 'riskScoreImpact'
                },
                contextId: AllFormData?.contextId,
                // resolutionDate: AllFormData?.taskResponse?.resolutionDate,
                resolutionDate: new Date()?.toISOString(),
                remarks: AllFormData?.taskResponse?.remarks,
                taskListRequests: AllFormData?.taskListResponse?.map((dt) => {
                    return {
                        name: dt?.name,
                        startDate: new Date()?.toISOString(),
                        endDate: new Date()?.toISOString(),
                        // startDate: dt?.startDate,
                        // endDate: dt?.endDate,
                        departmentId: 1,
                        assignee: dt?.assignee,
                        percentage: dt?.percentage,
                        status: 8
                    }
                })
            })
                .then((res) => {
                    if (res?.err) {
                        console.warn(res.err)
                        return
                    }
                    getRiskDetailsInitial(1, 10, 1, 1, 1)
                    getRiskDetailsAnalyz(1, 10, 1, 2, 1)
                    getRiskDetailsMitigation(1, 10, 1, 3, 1)
                    getRiskDetailsMonitoring(1, 10, 1, 4, 1)
                })
                .catch((err) => console.warn(err))
            const l1Approval = {
                contextId: AllFormData?.contextId,
                title: AllFormData?.title,
                description: AllFormData?.description,
                // identifiedOn: AllFormData?.identifiedOn,
                identifiedOn: new Date()?.toISOString(),
                sourceRiskId: 1,
                type: 1,
                category: 1,
                impactedDepartmentIds: [
                    1
                ],
                impactOfRisk: AllFormData?.impactOfRisk,
                ownerDepartmentId: 1,
                // impact: typeof AllFormData?.impact === 'string' ? AllFormData?.impact.split('(') : AllFormData?.impact,
                // probability: typeof AllFormData?.probability === 'string' ? AllFormData?.probability.split('(') : AllFormData?.probability,
                // riskScore: typeof AllFormData?.riskScore === 'string' ? AllFormData?.riskScore.split('(') : AllFormData?.riskScore,
                impact: 3,
                probability: 3,
                riskScore: 9,
                suggestedMitigation: AllFormData?.suggestedMitigation,
                suppprtingDocuments: AllFormData?.suppprtingDocuments,
                level1: AllFormData?.level1,
                level2: AllFormData?.level2,
                Status: 9
            }
            const RiskSummaryformValue = new FormData()
            Object.entries(l1Approval).forEach(([ key, value ]) => {
                RiskSummaryformValue.append(key, value)
            })
            CreateRisk(1, RiskSummaryformValue)
            const formValue = new FormData()
            Object.entries({
                ContextId: AllFormData?.contextId,
                ReferenceId: AllFormData?.referenceId,
                MeasuresId: 1,
                Description: AllFormData?.mitigation?.mitigationDescription,
                MitigationBudget: Number(AllFormData?.mitigation?.mitigationBudget),
                AvailableAmount: Number(AllFormData?.mitigation?.availableAmount)
            }).forEach(([ key, value ]) => {
                formValue.append(key, value)
            })
            RiskAPI.createMitigationPlan(formValue)
                .then((res) => {
                    if (res?.err) {
                        console.warn(res.err)
                        return
                    }
                    getRiskDetailsInitial(1, 10, 1, 1, 1)
                    getRiskDetailsAnalyz(1, 10, 1, 2, 1)
                    getRiskDetailsMitigation(1, 10, 1, 3, 1)
                    getRiskDetailsMonitoring(1, 10, 1, 4, 1)
                })
                .catch((err) => console.warn(err))
            setTimeout(() => {
                customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE, <div>{RoutePath.RISK.NAME}</div>)
            }, 1000)
        } else if (location?.state?.selectedMenu === 'Monitoring') {
            const l1Approval = {
                contextId: AllFormData?.contextId,
                title: AllFormData?.title,
                description: AllFormData?.description,
                identifiedOn: new Date()?.toISOString(),
                // identifiedOn: AllFormData?.identifiedOn,
                sourceRiskId: 1,
                type: 1,
                category: 1,
                impactedDepartmentIds: [
                    1
                ],
                impactOfRisk: AllFormData?.impactOfRisk,
                ownerDepartmentId: 1,
                impact: typeof AllFormData?.impact === 'string' ? AllFormData?.impact.split('(') : AllFormData?.impact,
                probability: typeof AllFormData?.probability === 'string' ? AllFormData?.probability.split('(') : AllFormData?.probability,
                riskScore: typeof AllFormData?.riskScore === 'string' ? AllFormData?.riskScore.split('(') : AllFormData?.riskScore,
                suggestedMitigation: AllFormData?.suggestedMitigation,
                suppprtingDocuments: AllFormData?.suppprtingDocuments || [],
                level1: 3,
                level2: 3,
                status: 7
            }
            const formValue = new FormData()
            Object.entries(l1Approval).forEach(([ key, value ]) => {
                formValue.append(key, value)
            })
            CreateRisk(1, formValue)
            setTimeout(() => {
                getRiskDetailsInitial(1, 10, 1, 1, 1)
                getRiskDetailsAnalyz(1, 10, 1, 2, 1)
                getRiskDetailsMitigation(1, 10, 1, 3, 1)
                getRiskDetailsMonitoring(1, 10, 1, 4, 1)
                customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE, <div>{RoutePath.RISK.NAME}</div>)
            }, 1000)
        }
    }

    useEffect(() => {
        if (RiskDetailsById) {
            setAllFormData(RiskDetailsById)
        }
    }, [RiskDetailsById])

    useEffect(() => {
        getRidkDetailsById(location?.state?.riskDetails, 1)
    }, [])

    const onChange = () => {
        setChecked(!checked)
    }

    const accordianValues = [
        { isCompleted: true, title: t('Risk Summary'), component: <RiskSummary AllFormData={AllFormData} setAllFormData={setAllFormData} /> },
        { isCompleted: true, title: t('Qualitiative Risk Assesment'), component: <QualitiativeRiskAssesment AllFormData={AllFormData} setAllFormData={setAllFormData} /> },
        { isCompleted: true, title: t('Quantitiative Risk Assesment'), component: <QuantitiativeRiskAssesment AllFormData={AllFormData} setAllFormData={setAllFormData} /> },
        { isCompleted: false, title: t('Mitigation'), component: <Mitigation AllFormData={AllFormData} setAllFormData={setAllFormData} /> }
    ]

    return (
        <div className='Risk-Details-container'>
            <Loading isLoading={RiskDetailsByIdLoading} />
            <div className='flex flex-row justify-end h-[5%]'>
                {/* <div className='flex flex-row justify-between items-center cursor-pointer px-4' >
                    <RiVideoAddLine color='hsl(var(--primary))' className='w-[27px] h-[27px] pr-2' />
                    <p style={{ color: 'hsl(var(--primary))' }}>{t('Meeting')}</p>
                </div> */}
                <div style={{ borderRight: '1px solid hsl(var(--primary))' }} />
                <div className='flex flex-row justify-between cursor-pointer items-center px-4' >
                    <MdOutlineCalendarMonth color='hsl(var(--primary))' className='w-[27px] h-[27px] pr-2' />
                    <p style={{ color: 'hsl(var(--primary))' }}>{t('Set Reminder')}</p>
                </div>
                <div style={{ borderRight: '1px solid hsl(var(--primary))' }} />
                <div className='flex flex-row justify-between cursor-pointer items-center px-4' >
                    <MdAccessTime color='hsl(var(--primary))' className='w-[27px] h-[27px] pr-2' />
                    <p style={{ color: 'hsl(var(--primary))' }} onClick={() => customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + RoutePath.CHAT_AND_TIMELINE.URI + '/' + location?.state?.riskDetails, <div>{RoutePath.CHAT_AND_TIMELINE.NAME}</div>)}>{t('Chat & Timeline')}</p>
                </div>
            </div>
            {location?.state?.selectedMenu === 'Initiation'
                ? <ViewRisk RiskDetailsById={RiskDetailsById} />
                // ? <div className='h-full overflow-auto p-[16px]'>
                //     <div className='p-[10px] bg-card'>
                //         <RiskSummary RiskDetailsById={RiskDetailsById} />
                //     </div>
                // </div>
                : <div className='h-full overflow-auto'>
                    {accordianValues?.map((data, index) => {
                        const element = (<Accordion key={index} sx={{ margin: '16px 16px', '&.Mui-expanded': { margin: '16px 16px' } }} expanded={expanded === data?.title} onChange={handleChangeRiskAccordian(data?.title)}>
                            <AccordionSummary expandIcon={<IconButton><IoIosArrowDown color='hsl(var(--primary))' /></IconButton>} >
                                <Typography sx={{ width: '100%', display: 'flex', flexDirection: 'row', flexShrink: 0 }}>
                                    <Typography sx={{ width: '60%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                        <Typography sx={{ width: '10%' }}>
                                            <Tooltip title="Disapprove" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                <IconButton>
                                                    <IoCheckmarkCircle style={{ height: '30px', width: '30px' }} color='hsl(var(--grey))' />
                                                </IconButton>
                                            </Tooltip>
                                        </Typography>
                                        <Typography sx={{ width: '90%' }}>
                                            <Typography sx={{ color: 'hsl(var(--primary))', fontWeight: 'bold' }}>{data?.title}</Typography>
                                        </Typography>
                                    </Typography>
                                    <Typography sx={{ color: 'text.secondary', width: '40%', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                        <Typography >
                                            <Typography sx={{ color: 'hsl(var(--primary))', fontSize: '13px', pr: 2, fontWeight: 'bold' }}>{data?.title} :</Typography>
                                        </Typography>
                                        <Typography>
                                            <Typography sx={{ fontSize: '13px', fontWeight: 'bold' }}>{data?.title}</Typography>
                                        </Typography>
                                    </Typography>
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {data.component}
                            </AccordionDetails>
                        </Accordion>)
                        if (location?.state?.selectedMenu === 'Analyze') {
                            return (data?.title !== 'Mitigation' && element)
                        } else {
                            return element
                        }
                    })}
                    <Accordion sx={{ margin: '16px 16px', '&.Mui-expanded': { margin: '16px 16px' } }} expanded={checked} >
                        <AccordionSummary >
                            <Typography sx={{ width: '100%', display: 'flex', flexDirection: 'row', flexShrink: 0 }}>
                                <Typography sx={{ width: '60%', display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignItems: 'center' }}>
                                    <Typography sx={{ width: '90%' }}>
                                        <Typography sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}><Typography sx={{ color: 'hsl(var(--primary))', fontWeight: 'bold', pr: 2 }}>{t('convert to issue if not closed before')}</Typography><ToggleSwitch onChange={onChange} isChecked={checked} /></Typography>
                                    </Typography>
                                </Typography>
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                                <Box gridColumn="span 3">
                                    <DateInput value={AllFormData?.createdDate} name='createdDate' register={register} onValueChange={(name, e) => setAllFormData({ ...AllFormData, [name]: e })} label={t('Date')} required />
                                </Box>
                                <Box gridColumn="span 6">
                                    <Input errors={errors} control={control} required rules={{ required: 'This field is required' }} name='description' label={t('Description')} register={register} placeholder="Enter Description" type="text" value={AllFormData?.createdDate} onValueChange={(name, e) => setAllFormData({ ...AllFormData, [name]: e })} />
                                </Box>
                            </Box>
                        </AccordionDetails>
                    </Accordion>
                </div>}
            {<div className='Risk-Details-footer'>
                <div className='flex flex-row justify-end'>
                    {location?.state?.selectedMenu && location?.state?.selectedMenu === 'Initiation' && <Button variant="outline" className={'mr-5 bg-card ml-4'} onClick={handleSubmit(handleCancel)} disabled={isLoading || isSubmitting}>{t('Reject')}</Button>}
                    {location?.state?.selectedMenu && location?.state?.selectedMenu !== 'Initiation' && <Button className={'mr-5 ml-4'} onClick={handleSubmit(handleSubmitViewRiskDetails)} disabled={isLoading || isSubmitting}>{t('Save')}</Button>}
                    {location?.state?.selectedMenu && <Button className={'mr-5 ml-4'} onClick={handleSubmitViewRiskDetails}>{t('Accept')}</Button>}
                    {!location?.state?.selectedMenu && <Button className={'mr-5 ml-4'} >{t('Retrieve Risk')}</Button>}
                </div>
            </div>}
        </div>
    )
}

export default ViewRiskDetailsById
